import { ReconciliationContent } from "../../components/invoice";

export default function Reconciliation() {
  return <ReconciliationContent />;
}
